module.exports = __webpack_public_path__ + "img/UI_shouji_buttonA_01_35aa4c497.png";